import { AlertTriangle } from "lucide-react";

export function LoanWarning({ className = "" }: { className?: string }) {
  return (
    <div
      className={`flex items-start gap-3 rounded-md border border-border bg-card p-4 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
      <p className="text-[12.5px] leading-relaxed text-foreground">
        <b>Att låna kostar pengar!</b> Om du inte kan betala tillbaka skulden i tid riskerar du en betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och skuldrådgivningen i din kommun. Kontaktuppgifter finns på konsumentverket.se.
      </p>
    </div>
  );
}
